<template>
    <div class="container menu">
            <!--es la cabecera para seccionar -->
            <div class="ui secondary menu">
                <div class="left menu">
                    <router-link class="left-item" to="/">
                        
                        <img class="ui small item" src="../assets/icono-pagina.png" /> 

                        <template v-for="category in categories" :key="category.id">
                            <router-link class="category-item" :to="category.slug">
                                {{ category.title }}
                            </router-link>
                        </template>
                    </router-link>
                </div>
                <div class="right menu">
                    <router-link class="item" to="/login" v-if="!token">
                        <p><i class="fas fa-user"></i> Iniciar Sesión</p>
                    </router-link>
                    
                    <template v-if="token">
                        <router-link class="item" to="/orders">
                            <p>pedidos</p>
                        </router-link>
                        <span class="ui item cart">
                            <i class="shopping cart icon" @click="openCart"></i>
                        </span>
                        <span class="ui item logout" @click="logout">
                            <i class="sign-out icon"></i>
                        </span>
                    </template>
                </div>
        </div>
            <nav class="menu">
            <div>
                
            </div>

                <!-- <ul>
                        <li class="nav_li"><a href="/"><i class="fas fa-home"></i> Inicio</a></li>
                        
                        <li class="nav_li"><a href="#">Quienes somos?</a></li>
                        <li class="nav_li"><a href="#">Contáctanos!</a></li>
                        <li class="nav_li"><a href="#">Nuestras Redes!</a></li>
                </ul> -->
            </nav>
    </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useStore } from 'vuex';
import { getTokenApi, deleteTokenApi } from '../api/token';
import { getCategoriesApi } from '../api/category';
export default {
    name:'Menu',
    setup(){
        let categories= ref(null);
        const token = getTokenApi();
        const store = useStore();

        onMounted( async ()=>{
            const response= await getCategoriesApi();
            categories.value =response;
        });

        const logout= ()=>{
            deleteTokenApi();
            location.replace('/');
        };

        const openCart=()=>{
            store.commit('setShowCart', true);
        };
        return{
            token,
            logout,
            categories,
            openCart
        }
    }
};
</script>

<style scoped>
/*----------------------------INICIO DE HEADER--------------------------------*/
.container.menu{
    background-image: url(../assets/banner.png);
    font-size: 15px;
}
.ui.secundary.menu{
    margin: 20px 20px;
    padding: 10px;
    font-size: 25px;
}
.left.menu{
    display: flex;
    margin-top: 0;
    flex-direction: column;
    width: 40%;
}
.category-item{
    justify-content: center;
}
.left-item > img{
    height: 80px;
}
.left.menu > .left-item{
    width: 50%;
    padding-top: 15px;
    padding-left: 20%;
}
/*-----------------RIHGT------------------*/
.right.menu{
    width: 40%;
    display: flex;
    justify-content: center;
}
.item >p{
    font-size: 15px;
    align-self: center;
    color: #fff;
}
.right.menu .item >  p:hover{
    cursor: pointer;
    color: blue;
    text-decoration: underline;
}
.right.menu .item > i:hover{
    cursor: pointer;
    color: blue;
}
/*--------------------------login right menu------------------------------------------*/
/* icono de carro */

.ui.item.cart{
    font-size: 17px;
    padding-left: 1px;
}
.ui.item.logout{
    font-size: 17px;
    padding-left: 1px;
}
/* .search-bar > input:focus{
    border-color: #fff;
    background: linear-gradient(to bottom, transparent, #000);/*enfoque de color semi transparente de un color 
}*/

/*----------------------------NAV Y MENU--------------------------------*/

.container.menu >nav{
    display:flex;
    justify-content: center;
    height: 20px;
}
nav div{
    margin-bottom: 20px;
}
.category-item{
    align-self: flex-end;
    font-style: bold;
    padding: 0 15px;
    color: #fff;
    font-size: 18px;
}
.category-item:hover{
    color: yellow;
    text-decoration: underline;
}
/*
nav >ul, a{
    color: #fff;
    text-decoration: none;
    list-style: none;
}
nav ul .nav_li > a{
    font-size: 18px;
}
li > a:hover{
    
    color: yellow;
    text-decoration: underline;
}

nav >ul{
    display: flex;
    padding-left: 3px;
    flex-wrap: wrap;
    justify-content: space-between,center;
}
.li-container{
    justify-self: center;
}
ul>li{
    margin: 10px;
    padding-left: 35px;
} */
@media screen and (max-width:600px) {
.right.menu{
    width: 50%;
    height: 100px;
}

}
</style>